/** รหัส CF ต่อ session — uppercase, A-Z0-9-, สูงสุด 10 ตัว */
export function normalizeCfCode(raw: string): string {
  return raw
    .trim()
    .toUpperCase()
    .replace(/[^A-Z0-9-]/g, "");
}

export function isValidCfCode(code: string): boolean {
  return code.length >= 1 && code.length <= 10;
}

/**
 * ค่า CF จาก Admin `products.barcode_prefix` + `product_variants.sku`
 * (เดียวกับ POS retail barcode scan value)
 */
export function resolveDefaultCfCode(input: {
  barcodePrefix?: string | null;
  sku?: string;
}): string | null {
  return deriveCfCodeFromBarcode(input.barcodePrefix, input.sku ?? "");
}

export function deriveCfCodeFromBarcode(
  barcodePrefix: string | null | undefined,
  sku: string,
): string | null {
  const prefix = (barcodePrefix ?? "").trim();
  const variantSku = (sku ?? "").trim();
  const combined = normalizeCfCode(`${prefix}${variantSku}`);
  if (isValidCfCode(combined)) return combined;

  const fromSku = normalizeCfCode(variantSku);
  if (isValidCfCode(fromSku)) return fromSku;

  const fromPrefix = normalizeCfCode(prefix);
  if (isValidCfCode(fromPrefix)) return fromPrefix;

  return null;
}
